var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 56,
    viewBox: "0 0 81 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 20.8333L57.3472 16.6606C57.6266 16.521 57.9371 16.4551 58.2492 16.4691C58.5612 16.4832 58.8645 16.5768 59.1303 16.741C59.396 16.9051 59.6154 17.1345 59.7676 17.4073C59.9199 17.6801 59.9998 17.9873 60 18.2996V30.7003C59.9998 31.0127 59.9199 31.3199 59.7676 31.5926C59.6154 31.8654 59.396 32.0948 59.1303 32.259C58.8645 32.4232 58.5612 32.5167 58.2492 32.5308C57.9371 32.5449 57.6266 32.4789 57.3472 32.3393L49 28.1666V20.8333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 17.1667C27 16.1942 27.3863 15.2616 28.0739 14.5739C28.7616 13.8863 29.6942 13.5 30.6667 13.5H45.3333C46.3058 13.5 47.2384 13.8863 47.9261 14.5739C48.6137 15.2616 49 16.1942 49 17.1667V31.8333C49 32.8058 48.6137 33.7384 47.9261 34.4261C47.2384 35.1137 46.3058 35.5 45.3333 35.5H30.6667C29.6942 35.5 28.7616 35.1137 28.0739 34.4261C27.3863 33.7384 27 32.8058 27 31.8333V17.1667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 30.25V10.5357C77.5 5.54543 73.5182 1.5 68.6064 1.5H10.3936C5.48181 1.5 1.5 5.54543 1.5 10.5357V38.4643C1.5 43.4546 5.48181 47.5 10.3936 47.5H60.5213",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 35.5C74.5 34.9477 74.0523 34.5 73.5 34.5C72.9477 34.5 72.5 34.9477 72.5 35.5H74.5ZM72.7929 55.2071C73.1834 55.5976 73.8166 55.5976 74.2071 55.2071L80.5711 48.8431C80.9616 48.4526 80.9616 47.8195 80.5711 47.4289C80.1805 47.0384 79.5474 47.0384 79.1569 47.4289L73.5 53.0858L67.8431 47.4289C67.4526 47.0384 66.8195 47.0384 66.4289 47.4289C66.0384 47.8195 66.0384 48.4526 66.4289 48.8431L72.7929 55.2071ZM72.5 35.5V54.5H74.5V35.5H72.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadVideo);
export default __webpack_public_path__ + "static/media/download-video.4cde369af2851decb8a5fdb8f4a40965.svg";
export { ForwardRef as ReactComponent };